import { PillsButton, RecommendedProducts, RecommendedProductsEmpty } from '@digital-retail/recommended-products';
import { cx } from 'cvb';
import PropTypes from 'prop-types';
import { withApplicationContext } from '../../utils/ApplicationContext';
import { withProduct } from '../../utils/ProductContext';
import { EMPTY_GROUP_IMG, textDictionary } from './constants';
import { styles } from './PillsButtonCarousel.style';
import { usePillsButtonCarouselHook } from './usePillsButtonCarouselHook';

const PillsButtonCarousel = ({ appCtx, product, rutHash }) => {
  const {
    deviceType,
    groupAnalytics,
    carouselAnalytics,
    recoProducts,
    groups,
    onClickGroupId,
    handleVisible,
    products,
    viewMoreUrl,
    showMore,
    hasProducts,
  } = usePillsButtonCarouselHook({ appCtx, product, rutHash });
  return (
    <div className={cx(groups.length && 'pills-button-container')} data-testid="pills-button-carousel">
      <PillsButton
        dataTestid="pills-button"
        tabs={groups}
        labels={{
          title: recoProducts.carouselName || textDictionary.recommendedProducts,
          knowMoreUrl: viewMoreUrl,
          knowMoreText: textDictionary.recommendedKnowMore,
        }}
        onClickGroupId={onClickGroupId}
        isLoading={recoProducts.isLoading}
        isFirstLoad={recoProducts.isFirstLoad}
        selectedGroupId={recoProducts.selectedGroupId}
        onVisible={handleVisible}
        lazyLoad
        analytics={groupAnalytics}
        showMore={showMore}
      >
        <div className="pills-button-body">
          {hasProducts ? (
            <div className="products-carousel">
              <RecommendedProducts
                products={products}
                deviceType={deviceType}
                labels={{
                  podButtonText: textDictionary.viewProduct,
                }}
                analytics={carouselAnalytics}
                pillsButtonsWrapper
                data-testid="recommended-products"
              />
            </div>
          ) : (
            <div className="pills-button-empty" data-testid="pills-button-carousel-empty">
              <RecommendedProductsEmpty image={EMPTY_GROUP_IMG}>
                No podemos mostrar los productos de esta sección. Descubre otras categorías o&nbsp;
                <a className="carousel-link" href={viewMoreUrl}>
                  revisa todo de {recoProducts.selectedGroup?.groupName}
                </a>
                .
              </RecommendedProductsEmpty>
            </div>
          )}
        </div>
      </PillsButton>
      <style jsx>{styles}</style>
    </div>
  );
};

PillsButtonCarousel.defaultProps = {
  appCtx: {},
  product: {},
  rutHash: '',
};

PillsButtonCarousel.propTypes = {
  appCtx: PropTypes.object,
  product: PropTypes.object,
  rutHash: PropTypes.string,
};

export const PillsButtonContainer = withApplicationContext(withProduct(PillsButtonCarousel));
